function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "color",
  points: "100.0,200.0 150.0,186.60254037844388 186.60254037844385,150.0 200.0,100.0 186.60254037844388,50.00000000000002 150.00000000000003,13.397459621556152 100.00000000000001,0.0 50.00000000000003,13.397459621556123 13.397459621556152,49.99999999999996 0.0,99.99999999999999 13.397459621556095,149.99999999999994 49.99999999999996,186.60254037844385",
  stroke: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "black",
  fillOpacity: 0.4,
  points: "100.0,200.0 150.0,186.60254037844388 186.60254037844385,150.0 200.0,100.0 186.60254037844388,50.00000000000002 150.00000000000003,13.397459621556152 100.00000000000001,0.0 50.00000000000003,13.397459621556123 13.397459621556152,49.99999999999996 0.0,99.99999999999999 13.397459621556095,149.99999999999994 49.99999999999996,186.60254037844385",
  stroke: "black"
});

var SvgD100 = function SvgD100(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    baseProfile: "full",
    height: "200px",
    viewBox: "0 0 200 200",
    width: "200px",
    xmlnsev: "http://www.w3.org/2001/xml-events",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgD100, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/d100.cbfd4095.svg";
export { ForwardRef as ReactComponent };